import type { MessageKey } from "./ru"

export const trMessages = {
  "common.loading": "Yükleniyor...",
  "common.error": "Hata",
  "common.back": "Geri",
  "common.next": "İleri",
  "common.search": "Ara",
  "auth.loginErrorTitle": "Giriş hatası",
  "auth.openViaTelegram": "Uygulamayı Telegram üzerinden açın",
  "auth.telegramRequired": "Uygulama Telegram üzerinden açılmalıdır",
  "auth.authorizationError": "Yetkilendirme hatası",
  "device.rotatePortrait": "Cihazınızı dikey konuma çevirin",
  "country.brazil": "Brezilya",
  "country.vietnam": "Vietnam",
  "country.egypt": "Mısır",
  "country.india": "Hindistan",
  "country.indonesia": "Endonezya",
  "country.iran": "İran",
  "country.spain": "İspanya",
  "country.italy": "İtalya",
  "country.kazakhstan": "Kazakistan",
  "country.colombia": "Kolombiya",
  "country.malaysia": "Malezya",
  "country.mexico": "Meksika",
  "country.nigeria": "Nijerya",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusya",
  "country.usa": "Amerika Birleşik Devletleri",
  "country.turkey": "Türkiye",
  "country.uzbekistan": "Özbekistan",
  "country.ukraine": "Ukrayna",
  "country.philippines": "Filipinler",
  "countrySelection.chooseCountry": "Ülke seçin",
  "countrySelection.openAria": "Ülke seç",
  "languageSelection.chooseLanguage": "Dil seçin",
  "commercial.direction.autotrade": "Oto Market",
  "commercial.direction.insurance": "Sigorta",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Yol Yardımı",
  "commercial.searchLabel": "BeepApp araması",
  "commercial.cityPlaceholder": "Şehir girin",
  "commercial.emptyTitle": "Bugün teklif yok",
  "commercial.emptyLine1": "Şehrinizde henüz aktif BeepApp iş ortağı yok",
  "commercial.emptyLine2": "Onları bulmak ve bağlamak için çalışıyoruz",
  "commercial.emptyLine3": "Yeni teklifler burada otomatik olarak görünecek",
  "commercial.helperLine1": "Mevcut teklifleri görmek için",
  "commercial.helperLine2": "şehrinizi girin",
  "commercial.partnerPrompt": "BeepApp iş ortağı olmak ister misiniz?",
  "commercial.apply": "Başvur",
  "main.admin": "Yönetici",
  "main.garage": "Garaj",
  "main.signalSent": "Sinyal gönderildi",
  "main.partnerInviteUnavailable": "İş ortağı daveti kullanılamıyor",
  "main.enterPlate": "Plaka girin",
  "main.searchError": "Arama hatası",
  "main.signalSendError": "Sinyal gönderilemedi",
  "main.shareCardPrefix": "Plaka kartı",
  "main.shareLinkError": "Bağlantı hazırlanamadı",
  "main.searchByPlateAria": "Plakaya göre ara",
  "main.russianPlateAria": "Rusya plakası",
  "main.plateAria": "Plaka",
  "main.findPlateAria": "Plakayı bul",
  "main.loadingVehicle": "Plaka kartı yükleniyor…",
  "main.leaveSignal": "Sinyal gönder",
  "main.share": "Paylaş",
  "signalSelection.chooseType": "Sinyal türünü seçin",
  "signalSelection.category.attention": "Kişisel",
  "signalSelection.category.road": "Trafik",
  "signalSelection.category.urgent": "Acil",
  "signalSelection.chooseSignal": "Sinyal seçin",
  "signalSelection.suggestOwn": "Kendi seçeneğini öner",
  "signalConfirmation.title": "Sinyali onayla",
  "signalConfirmation.plateHeading": "Araç plakasını kontrol edin",
  "signalConfirmation.signalHeading": "Seçilen sinyali kontrol edin",
  "signalConfirmation.replyTitle": "Telegram yanıtına izin ver",
  "signalConfirmation.replyBody": "Bu özelliği açarsanız plaka sahibi size\nTelegram üzerinden yazabilir. Yanıt yalnızca\n@username sahibiyseniz mümkündür. Yanıt verme\nkararı plaka sahibine aittir.",
  "signalConfirmation.consentText": "Sinyalin gerçek bir durumu yansıttığını\nve spam ya da yanlış bildirim olmadığını\nonaylıyorum.",
  "signalConfirmation.warning": "Gönderdikten sonra sinyal\ndeğiştirilemez",
  "signalConfirmation.sending": "Gönderiliyor…",
  "signalConfirmation.send": "Gönder",
  "partner.loadingAria": "Yükleniyor",
  "partner.title": "İş Ortaklığı Programı",
  "partner.offerLine1": "Davet ettiğiniz kullanıcıların tüm ödemelerinden",
  "partner.offerLine2": "süresiz %30 kazanın",
  "partner.offerLine3": "Telegram affiliate programı üzerinden",
  "partner.connectUnavailable": "Bağlantı, Telegram Affiliate Programı yapılandırıldıktan sonra kullanılabilir olacak.",
  "partner.connectTelegram": "Telegram ile bağlan",
  "partner.qrAria": "İş ortağı bağlantısı QR kodu",
  "partner.download": "İndir",
  "partner.promoHeading": "Kişisel promosyon kodu oluşturun",
  "partner.promoHelperLine1": "Promosyon kodu ek bir yıllık abonelik açar",
  "partner.promoHelperLine2": "ve kullanıcı çekmenize yardımcı olur",
  "partner.promoAria": "Promosyon kodu",
  "partner.affiliateHeading": "Affiliate bağlantınız",
  "partner.affiliateHelper": "Kişisel QR kodu oluşturmak için bağlantıyı kaydedin",
  "partner.affiliateAria": "Affiliate bağlantısı",
  "partner.qrNoteLine1": "QR kodu aracınıza,",
  "partner.qrNoteLine2": "sosyal medyaya ve reklam materyallerine yerleştirebilirsiniz",
  "partner.save": "Kaydet",
  "partner.reset": "Sıfırla",
  "partner.resetConfirm": "Kaydedilmiş affiliate bağlantısı sıfırlansın mı? Promosyon kodu sizde kalacak.",
  "partner.promoFormatError": "Promosyon kodu 4 ile 15 karakter arasında olmalıdır.",
  "partner.affiliateHostError": "Yalnızca t.me veya telegram.me bağlantılarına izin verilir.",
  "partner.affiliatePathError": "Bağlantıda Telegram yolu bulunmuyor.",
  "partner.affiliateFormatError": "Geçersiz affiliate bağlantısı.",
  "partner.loadError": "Yükleme hatası",
  "partner.checkInputError": "Girilen bilgileri kontrol edin",
  "garageActivation.promoInvalid": "Promosyon kodu geçersiz",
  "garageActivation.plateOccupied": "Bu plaka zaten bağlı",
  "garageActivation.activateError": "Garaj etkinleştirilemedi",
  "garageEntry.loadJournalError": "Seyir defteri yüklenemedi",
  "garageEntry.loadStatusesError": "Durumlar yüklenemedi",
  "garageEntry.activationSuccess": "Garaj başarıyla etkinleştirildi",
  "garageEntry.plateAttached": "Plaka bağlandı",
  "garageEntry.attachError": "Plaka bağlanamadı",
  "garageEntry.activationNote": "Garajınızı etkinleştirin",
  "garageSheet.activationTitle": "Garajı etkinleştirme",
  "garageSheet.plateHelper": "Araç plakasını girin",
  "garageSheet.promoHelper": "Promosyon kodunuz var mı?",
  "garageSheet.cleanBonusLine1": "Etkinleştirmeden sonra 1 saatiniz olacak",
  "garageSheet.cleanBonusLine2": "ücretsiz “Temiz Başlangıç” için",
  "garageSheet.activationFor": "Etkinleştirme süresi",
  "garageSheet.cost": "Ücret",
  "garageSheet.ownerConsentLine1": "Belirtilen plakaya sahip aracın",
  "garageSheet.ownerConsentLine2": "sahibi olduğumu",
  "garageSheet.ownerConsentLine3": "onaylıyorum.",
  "garageSheet.processing": "İşleniyor...",
  "garageSheet.attach": "Bağla",
  "garageSheet.pay": "Öde",
  "garageLifecycle.cleanTitle": "Temiz Başlangıç",
  "garageLifecycle.deactivateTitle": "Garajı Devre Dışı Bırak",
  "garageLifecycle.cleanWarningLine1": "Plaka geçmişi silinecek",
  "garageLifecycle.cleanWarningLine2": "ve geri alınamayacak!",
  "garageLifecycle.deactivateWarningLine1": "Devre dışı bıraktıktan sonra aktif",
  "garageLifecycle.deactivateWarningLine2": "Garaj özelliklerine erişim sona erecek",
  "garageLifecycle.willBeDeleted": "SİLİNECEK",
  "garageLifecycle.cleanRemovedLine1": "• Seyir Defterindeki tüm kayıtlar",
  "garageLifecycle.cleanRemovedLine2": "• Alınan sinyal geçmişi",
  "garageLifecycle.cleanRemovedLine3": "• Herkese açık sinyal sayaçları",
  "garageLifecycle.cleanRemovedLine4": "  plaka kartında",
  "garageLifecycle.willRemain": "KALACAK",
  "garageLifecycle.cleanPreservedLine1": "• Plakanın Garaja bağlantısı",
  "garageLifecycle.cleanPreservedLine2": "• Kalan etkinleştirme süresi",
  "garageLifecycle.cleanPreservedLine3": "• Seçilen plaka durumu",
  "garageLifecycle.cleanPreservedLine4": "• Toplam plaka kartı görüntülenmesi",
  "garageLifecycle.freeFirstHour": "İlk saat ücretsiz",
  "garageLifecycle.willBecomeUnavailable": "KULLANILAMAZ OLACAK",
  "garageLifecycle.deactivateRemovedLine1": "• Seyir Defteri",
  "garageLifecycle.deactivateRemovedLine2": "• Plaka durumu seçme ve kullanma",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan üyeliğinden otomatik çıkış",
  "garageLifecycle.deactivateRemovedLine4": "• Oto Market",
  "garageLifecycle.deactivateRemovedLine5": "• Sigorta",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Yol Yardımı",
  "garageLifecycle.deactivateRemovedLine8": "• Plaka Garajdan ayrılacak",
  "garageLifecycle.willRemainAvailable": "KULLANILABİLİR KALACAK",
  "garageLifecycle.deactivatePreservedLine1": "• Yol Arkadaşı",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Plaka arama ve görüntüleme",
  "garageLifecycle.deactivatePreservedLine4": "  herkese açık araç kartı",
  "garageLifecycle.deactivatePreservedLine5": "• İstediğiniz zaman Garajı",
  "garageLifecycle.deactivatePreservedLine6": "  yeniden etkinleştirme imkânı",
  "garageLifecycle.cleanConsentLine1": "Bu plakanın tüm geçmişinin",
  "garageLifecycle.cleanConsentLine2": "geri alınamayacak şekilde silinmesini",
  "garageLifecycle.cleanConsentLine3": "onaylıyorum.",
  "garageLifecycle.deactivateConsentLine1": "Devre dışı bırakmayı ve",
  "garageLifecycle.deactivateConsentLine2": "tüm aktif Garaj özelliklerine",
  "garageLifecycle.deactivateConsentLine3": "erişimin sona ermesini onaylıyorum.",
  "garageLifecycle.clean": "Temizle",
  "garageLifecycle.deactivate": "Devre dışı bırak",
} satisfies Record<MessageKey, string>
